/*
  tabShow 是否展示底部导航
  keepAlive 是否需要缓存组件
  noLogin 页面是否开启免登录
  
*/

import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'

import { getToken, types } from '@/utils/Token'
import { Toast } from 'vant'

import store from '@/store'
Vue.use(VueRouter)

const router = new VueRouter({
	// mode: 'history',
	routes
})

const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err)
}

VueRouter.prototype.replace = function replace(location) {
	return originalPush.call(this, location).catch((err) => err)
}

router.beforeEach((to, from, next) => {
	if (getToken(types.Token) !== null) {
		if (to.path == '/login') {
			next('/')
		} else {
			next()
		}
	} else {
		Toast('请登录')
		if (to.path == '/login') {
				next();
			} else {
				next('/login')
			}	
			
	}

	// if(getToken(types.Token) !== null && getToken(types.Token) !== ""){
	//      if(to.path == '/login'){
	//        next('/')
	//      }else{
	//        next();
	//      }
	// }else{
	//   if(to.path == "/login"){
	//     next();
	//   }else{
	//     next("/login")
	//   }
	// }
	// next();
})

export default router
